import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = { class: "default-table-area style-two all-projects" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle" }
const _hoisted_5 = { class: "text-body" }
const _hoisted_6 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ms-m-15" }
const _hoisted_9 = { class: "text-body" }
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "d-flex align-items-center gap-1" }
const _hoisted_13 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_14 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_15 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_16 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_17 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_18 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_19 = { class: "p-4 pt-lg-4" }
const _hoisted_20 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_21 = { class: "fs-12 fw-medium" }
const _hoisted_22 = { "aria-label": "Page navigation example" }
const _hoisted_23 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">All Projects</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Week</option><option value=\"1\">This Month</option><option value=\"2\">This Year</option></select></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "ID"),
              _createElementVNode("th", { scope: "col" }, "Project Name"),
              _createElementVNode("th", { scope: "col" }, "Client"),
              _createElementVNode("th", { scope: "col" }, "Assignees"),
              _createElementVNode("th", { scope: "col" }, "Budget"),
              _createElementVNode("th", { scope: "col" }, "Start Date"),
              _createElementVNode("th", { scope: "col" }, "End Date"),
              _createElementVNode("th", { scope: "col" }, "Status"),
              _createElementVNode("th", { scope: "col" }, "Action")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems.slice(0, 5), (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(item.id), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, { to: "/project-management/project-overview" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.projectName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("td", null, _toDisplayString(item.client), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.assignees.images, (userImg) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: userImg.id,
                        class: _normalizeClass(item.assignees.className)
                      }, [
                        _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: userImg.image,
                              class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                              alt: "user"
                            }, null, 8, _hoisted_7)
                          ]),
                          _: 2
                        }, 1024)
                      ], 2))
                    }), 128)),
                    _createElementVNode("li", _hoisted_8, [
                      _createVNode(_component_RouterLink, {
                        to: "/users/users-list",
                        class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.assignees.number), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_9, "$" + _toDisplayString(item.budget), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(item.startDate), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(item.endDate), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                  }, _toDisplayString(item.status), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", _hoisted_13, [
                      _createElementVNode("i", _hoisted_14, _toDisplayString(item.action.view), 1)
                    ]),
                    _createElementVNode("button", _hoisted_15, [
                      _createElementVNode("i", _hoisted_16, _toDisplayString(item.action.edit), 1)
                    ]),
                    _createElementVNode("button", _hoisted_17, [
                      _createElementVNode("i", _hoisted_18, _toDisplayString(item.action.delete), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, " Showing " + _toDisplayString(_ctx.startItem + 1) + " to " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.items.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_22, [
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                  }, _toDisplayString(page), 9, _hoisted_24)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}